import {
  CdkVirtualScrollViewport,
  ScrollingModule,
} from "@angular/cdk/scrolling";
import { AsyncPipe, CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from "@angular/forms";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";

import { invalid } from "moment";

import { MatTooltipModule } from "@angular/material/tooltip";
import { CountryUiEnum } from "src/app/com/staybloom/uiproto/address/countryUiProto";
import { GroupedMultiselectComponent } from "../grouped-multiselect/grouped-multiselect.component";
import { MultiSelectOptionComponent } from "../multi-select-option/multi-select-option.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatIconModule } from "@angular/material/icon";
import { MAT_SELECT_CONFIG } from "@angular/material/select";
import {
  MatSlideToggleChange,
  MatSlideToggleModule,
} from "@angular/material/slide-toggle";
import { NgxMaterialTimepickerTheme } from "ngx-material-timepicker";
import { Subscription } from "rxjs";
import { formTypeActionEnum } from "src/app/_enums/ui-development/ui-development";
import { FormDataSimplified } from "src/app/_interfaces/formDataSimplified";
import { PipeModule } from "src/app/_pipes/pipe.module";
import { DialogControlService } from "src/app/_services/dialog-control.service";
import { ObjectUtilsService } from "src/app/_services/object-utils.service";
import { MaterialFormModule } from "src/app/_shared/material/material-form.module";
import { NgxTimpickerModule } from "src/app/_shared/ngx-timpicker/ngx-timpicker.module";
import { COUNTRIES_LIST } from "src/app/_utils/countries";
import { AccessUiPb } from "src/app/com/staybloom/accessControl/uiproto/accessControlUiProto";
import {
  RoleUiEnum,
  RoleUiPb,
} from "src/app/com/staybloom/common/uiproto/roleUiProto";
import { IdVerificationStatusUiEnum } from "src/app/com/staybloom/profile/uiproto/verificationUiProto";
import { S3ObjectUiPb } from "src/app/com/staybloom/s3Object/uiproto/s3ObjectUiProto";
import { SUPER_USER } from "src/app/constants/superUserConstant";
import { CountrySearchComponent } from "../country-search/country-search.component";
import {
  FieldTypeEnumSimplified,
  FieldWidthEnumSimplified,
} from "./../../_interfaces/formDataSimplified";
import { AuthenticationStoreService } from "src/app/stores/staybloom/authenticationStore/authenticationStore.services";
import { PageServiceService } from "src/app/_services/page-service.service";

@Component({
  selector: "app-dynamic-form-landing",
  templateUrl: "./dynamic-form-landing.component.html",
  styleUrls: ["./dynamic-form-landing.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: "custom_select_box_overlay" },
    },
  ],
  imports: [
    CommonModule,
    MaterialFormModule,
    MatIconModule,
    CountrySearchComponent,
    GroupedMultiselectComponent,
    PipeModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    AsyncPipe,
    PipeModule,
    MatTooltipModule,
    ScrollingModule,
    MultiSelectOptionComponent,
    NgxTimpickerModule,
  ],
})
export class DynamicFormLandingComponent implements OnChanges {
  @ViewChild("formRef")
  formRef: FormGroupDirective;
  firstInvalidControl: any;
  @Input() sectionClass: string;

  @ViewChild("dynamicform") dynamicform: any;
  @Input() formSections: FormDataSimplified[];
  @Input() data: any;
  @Input() formType: string;
  @Input("showButtons") showButtons: boolean;
  formTypeActionEnum = formTypeActionEnum;
  form: FormGroup;
  FieldTypeEnumSimplified = FieldTypeEnumSimplified;
  FieldWidthEnumSimplified = FieldWidthEnumSimplified;
  @Output() dynamicFormEvent = new EventEmitter<any>();
  @Output() closeCalenderEvent = new EventEmitter<any>();
  @Input("valuesToPatch") valuesToPatch: any;
  @ViewChild("virtualScroll", { static: false })
  virtualScroll!: CdkVirtualScrollViewport;

  darkTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: "#fff",
      buttonColor: "#6b6b6b",
    },
    dial: {
      dialBackgroundColor: "#ffcc09",
    },
    clockFace: {
      clockFaceBackgroundColor: "#fafafa",
      clockHandColor: "#ffcc09",
      clockFaceTimeInactiveColor: "#6b6b6b",
    },
  };
  @Output() fieldFocus = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<any>();
  searchValue: string;
  searchCountryValue: string;
  COUNTRIES_LIST = COUNTRIES_LIST;
  @Output() fieldValueChanged = new EventEmitter<any>();
  valueChangeSubscribe: Subscription;
  userRole: RoleUiPb;
  RoleUiEnum = RoleUiEnum;
  @Output() removeFrImageEvent = new EventEmitter<any>();
  @Input() sectionEnabled: boolean = true;
  isIdentityEnabled: boolean = true;
  isSuperUser: boolean = false;
  showImageError: string = "";
  nations: any = [];
  itemSize: number = 35;
  today = new Date();
  @Input("isSectionNameLight") isSectionNameLight: boolean = false;
  unsubscribePageService: Subscription;
  constructor(
    private formBuilder: FormBuilder,
    private dialogControlService: DialogControlService,
    private objectUtils: ObjectUtilsService,
    private _pageService: PageServiceService,
    private _authenticationStoreService: AuthenticationStoreService
  ) {
    this.unsubscribePageService = this._pageService
      .getCurrentHotelInventoryId()
      .subscribe((id) => {
        this.userRole =
          this._authenticationStoreService.getRoleForInventory(id);
      });
    console.log(this.userRole);
    if (this.userRole?.role?.includes(RoleUiEnum.SUPER_USER)) {
      this.isSuperUser = true;
    }
    this.convertEnumForList();
  }

  ngOnChanges() {
    console.log(this.formSections);
    // resetting unsaved images on form load
    this.formReset();
  }

  ngOnDestroy() {
    console.log(11980281092890);
    this.valueChangeSubscribe?.unsubscribe();
    this.unsubscribePageService.unsubscribe();
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
  }

  onDrop(event: any, field: any) {
    event.preventDefault();
    event.stopPropagation();
    this.fieldValueChanged.emit(true);
    if (event.dataTransfer.files.length > 0) {
      this.selectionImageByDragAndDrop(field, event);
    }
  }

  formReset(shouldResetAll: boolean = false) {
    if (this.formSections) {
      this.formSections?.forEach((element) => {
        if (element?.fields) {
          element.fields.forEach((fieldData) => {
            if (shouldResetAll) {
              fieldData.value = "";
            } else {
              if (
                fieldData.type !== FieldTypeEnumSimplified.SELECT &&
                fieldData.type !== FieldTypeEnumSimplified.CHECKBOX
              ) {
                fieldData.value = "";
              }
            }
          });
        }
      });
      this.form = this.formBuilder.group({});
    }
    this.intializeFormFields();
  }

  patchFormValues() {
    if (this.valuesToPatch && Object.keys(this.valuesToPatch).length) {
      for (const section of this.formSections) {
        if (section.sectionFromGroup) {
          const sectionFormGroup = this.form.get(
            section.sectionFromGroup
          ) as FormGroup;
          if (sectionFormGroup) {
            sectionFormGroup.patchValue(
              this.valuesToPatch[section?.sectionFromGroup]
            );
          }
        } else {
          for (const field of section.fields) {
            const control = this.form.get(field?.name);
            if (
              control &&
              Object.keys(this.valuesToPatch)?.includes(field?.name)
            ) {
              const patchedValue = this.valuesToPatch[field?.name];
              control.patchValue(patchedValue);
            }
          }
        }
      }
    } else {
      // this.form.reset();
    }

    this.valueChangeSubscribe = this.form?.valueChanges.subscribe(
      (changedValue) => {
        this.fieldValueChanged.emit(changedValue);
      }
    );
  }

  isArray(variable: any): boolean {
    return Array.isArray(variable);
  }

  intializeFormFields() {
    if (this.isArray(this.formSections)) {
      for (const section of this.formSections) {
        for (const field of section.fields) {
          let validators: any[] = [];

          if (field?.required) {
            validators.push(Validators.required);
          }

          if (field?.pattern) {
            validators.push(Validators.pattern(field.pattern));
          }
          let isIdentityDisabled: Boolean = false;
          if (
            section.sectionFromGroup == "identityDetails" &&
            !this.sectionEnabled
          ) {
            isIdentityDisabled = true;
            this.isIdentityEnabled = false;
          }
          const controlOptions = {
            value: field?.value,
            disabled:
              this.formType === formTypeActionEnum.EDITANDCHECKIN ||
              this.formType === formTypeActionEnum.EDIT ||
              field?.disabled,
          };
          if (section?.sectionFromGroup) {
            // Create a new FormGroup for the section
            const sectionFormGroup = this.formBuilder.group({});
            // Add the section's fields to the sectionFormGroup
            for (const field of section?.fields) {
              sectionFormGroup.addControl(
                field?.name,
                this.formBuilder.control(
                  field?.value,
                  field.required ? [Validators.required] : []
                )
              );
            }
            if (
              this.formType === formTypeActionEnum.EDITANDCHECKIN ||
              this.formType === formTypeActionEnum.EDIT ||
              section.disabled
            ) {
              sectionFormGroup.disable(); // Add the disabled attribute to the FormGroup
            }

            if (isIdentityDisabled) {
              section.fields.forEach((element) => {
                if (
                  element.name != "idProofFront" &&
                  element.name != "idProofBack"
                )
                  this.form
                    ?.get(section.sectionFromGroup)
                    ?.get(element.name)
                    ?.disable();
              });
            }
            // Add the sectionFormGroup to the main form
            this.form.addControl(section.sectionFromGroup, sectionFormGroup);
          } else {
            // Add a regular form control to the main form
            if (field?.formGroup) {
              const formGroup = this.formBuilder.group({});
              field.fields.forEach((ele) => {
                formGroup.addControl(
                  ele?.name,
                  this.formBuilder.control(
                    ele?.value,
                    ele.required ? [Validators.required] : []
                  )
                );
              });
              this.form.addControl(field.name, formGroup);
            } else {
              this.form.addControl(
                field?.name,
                this.formBuilder.control(
                  {
                    value: controlOptions.value,
                    disabled: controlOptions?.disabled,
                  },
                  validators
                )
              );
            }
          }
        }
      }
    }

    this.patchFormValues();
  }

  isTextAreaAvailable: boolean = false;

  onChangeHandler(event: any) {
    if (event.toUpperCase() === "OTHER") {
      this.isTextAreaAvailable = true;
    } else {
      this.isTextAreaAvailable = false;
    }
  }

  onSubmit() {
    this.dynamicFormEvent.emit(this.form);
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      setTimeout(() => {
        this.scrollToFirstError();
      }, 0);
    }
    return this.form;
  }

  onFieldFocus(field: any) {
    field.value = this.form.value[field.name];
    this.fieldFocus.emit(field);
  }

  onSelectionChange(field: any, $event: any, index?: number) {
    console.log("onSelectionChange");
    console.log($event);
    console.log(field);
    if (field.type == "file" || field?.type == "MULTIPLE_FILE") {
      if (index != undefined) {
        field.index = index;
      }
      if (field.name == "idProofFront" || field.name == "idProofBack") {
        this.form
          ?.get("identityDetails")
          ?.get("sendForVerification")
          ?.setValue(true);
        this.form
          ?.get("identityDetails")
          ?.get("idVerificationStatus")
          ?.setValue(IdVerificationStatusUiEnum.NOT_VERIFIED);
      }
      this.selectionImage(field, $event);
    } else {
      if (field.name == "idType") {
        this.form
          ?.get("identityDetails")
          ?.get("sendForVerification")
          ?.setValue(true);
        this.form
          ?.get("identityDetails")
          ?.get("idVerificationStatus")
          ?.setValue(IdVerificationStatusUiEnum.NOT_VERIFIED);
      }
      if (field.type == FieldTypeEnumSimplified.COUNTRY_CODE) {
        this.form?.get(field.name)?.setErrors(null);
        this.form?.get(field.name)?.clearValidators();
        this.form?.get(field.name)?.updateValueAndValidity();
      }
      this.selectionChange.emit({ field, $event });
    }
  }

  selectionImage(field: any, $event: any) {
    if ($event.target.files && $event.target.files[0]) {
      const maxSizeKB = 500;
      if ($event.target.files[0].size > maxSizeKB * 1024) {
        throw new Error("<show error> File size exceeds 500 KB limit."); // Throw an error if file size is too large
      } else {
        this.selectionChange.emit({ field, $event });
      }

      var reader = new FileReader();
      reader.readAsDataURL($event.target.files[0]); // read file as data url
      reader.onload = (event) => {
        let control = this.findFormControl(field.name);
        control.patchValue(event.target.result);
        field.value = event.target.result;
      };
    }
  }

  selectionImageByDragAndDrop(field: any, $event: any) {
    if ($event.dataTransfer.files && $event.dataTransfer.files[0]) {
      const maxSizeKB = 500;
      if ($event.dataTransfer.files[0].size > maxSizeKB * 1024) {
        throw new Error("<show error> File size exceeds 500 KB limit."); // Throw an error if file size is too large
      } else {
        this.selectionChange.emit({ field, $event, type: "dragAndDrop" });
      }

      var reader = new FileReader();
      reader.readAsDataURL($event.dataTransfer.files[0]); // read file as data url
      reader.onload = (event) => {
        let control = this.findFormControl(field.name);
        control.patchValue(event.target.result);
        field.value = event.target.result;
      };
    }
  }

  scrollToFirstError() {
    const firstInvalidControl = document.querySelector("input.ng-invalid");
    if (firstInvalidControl) {
      const parentWithScrollbar =
        this.findParentWithScrollbar(firstInvalidControl);

      if (parentWithScrollbar) {
        const firstInvalidControlRect =
          firstInvalidControl.getBoundingClientRect();
        const parentRect = parentWithScrollbar.getBoundingClientRect();
        const offsetTop =
          firstInvalidControlRect.top -
          parentRect.top +
          parentWithScrollbar.scrollTop;

        parentWithScrollbar.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    }
  }

  findParentWithScrollbar(element: any) {
    while (element.parentElement) {
      const style = getComputedStyle(element.parentElement);
      if (style.overflowY === "auto" || style.overflowY === "scroll") {
        return element.parentElement;
      }
      element = element.parentElement;
    }
    return null;
  }
  status() {
    return this.form;
  }
  findFormControl(
    fieldName: string,
    obj: any = this.form.value
  ): FormControl | null {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (key === fieldName) {
          return new FormControl(value);
        } else if (typeof value === "object" && value !== null) {
          const foundControl = this.findFormControl(fieldName, value);
          if (foundControl) {
            return foundControl;
          }
        }
      }
    }
    return null;
  }

  getData(field: any) {
    if (this.findFormControl(field.name)?.value) {
      return this.findFormControl(field.name)?.value;
    } else {
      return field.imagePlaceHolder;
    }
  }

  getDataArray(field: any) {
    if (this.findFormControl(field.name)?.value) {
      return this.findFormControl(field.name)?.value;
    } else {
      return field.imagePlaceHolder;
    }
  }

  closeModal(field: any, event: any, value: boolean, isTime: boolean = false) {
    const currentFormValue = this.form?.get(field.name)?.value;
    this.closeCalenderEvent.emit([
      field,
      event,
      value,
      isTime,
      currentFormValue,
    ]);
    if (field.name == "dateOfIssue" || field.name == "validUntil") {
      this.form
        ?.get("identityDetails")
        ?.get("sendForVerification")
        ?.setValue(true);
      this.form
        ?.get("identityDetails")
        ?.get("idVerificationStatus")
        ?.setValue(IdVerificationStatusUiEnum.NOT_VERIFIED);
    }
    this.closeCalenderEvent.emit([
      field,
      event,
      value,
      isTime,
      currentFormValue,
    ]);
  }

  searchEventHandle(event: Event) {
    this.searchValue = (event.target as HTMLInputElement).value;
  }

  searchCountryEventHandle(event: Event) {
    this.searchCountryValue = (event.target as HTMLInputElement).value;
  }

  focusOnSelect() {
    document.getElementById("searchInput").focus();
  }
  displayNameAutoComplete(data: any) {
    return data?.key;
  }

  checkIfRangeSelected(fieldName: string, parentField: string) {
    if (!this.form?.get(parentField)?.get(fieldName)?.value) {
      this.form
        ?.get(parentField)
        ?.get(fieldName)
        ?.setErrors({ required: true });
    } else {
      this.form?.get(parentField)?.get(fieldName)?.setErrors(null);
      this.form?.get(parentField)?.get(fieldName)?.clearValidators();
      this.form?.get(parentField)?.get(fieldName)?.updateValueAndValidity();
    }
  }

  getFrImageSource(field: any, index: number) {
    return !field?.value
      ? this.getDataArray(field)[index]?.signedURL
      : field?.value[index]?.signedURL;
  }

  removeFrImage(i: number) {
    this.removeFrImageEvent.emit(i);
  }

  openImage(imgSrc: string | S3ObjectUiPb) {
    let data = {
      imageSrc: imgSrc,
    };
    this.dialogControlService.openImage(data);
  }

  toggleSection(event: MatSlideToggleChange, section: FormDataSimplified) {
    this.isIdentityEnabled = event.checked;
    section.fields.forEach((element) => {
      if (event.checked) {
        this.form?.get(section.sectionFromGroup)?.get(element.name)?.enable();
      } else {
        if (element.name != "idProofFront" && element.name != "idProofBack") {
          this.form
            ?.get(section.sectionFromGroup)
            ?.get(element.name)
            ?.disable();
        }
      }
    });
  }

  convertEnumForList() {
    let countryList: any = CountryUiEnum;
    this.nations = this.objectUtils.convertEnumForList(countryList);
  }

  removeLiteralNewlines(event: Event, field: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    let newValue = textarea.value.replaceAll(/\\n/g, "");
    newValue = textarea.value.replaceAll(/\n/g, "");
    this.findFormControl(field.name).setValue(newValue);
  }

  removeNewLinesOnPaste(event: any, field: any): void {
    let clipboardData = event.clipboardData;
    let pastedData = clipboardData.getData("Text");
    var match = /\r|\n/.exec(pastedData);
    if (match) {
      event.preventDefault();
    }
  }

  onKeydown(event: any) {
    event.preventDefault();
  }

  getDynamicHeight(
    options: any[],
    maxHeight: number = 200,
    itemHeight: number = 30
  ): number {
    if (!options || options.length === 0) {
      return 0;
    }
    const calculatedHeight = options.length * itemHeight;
    return Math.min(calculatedHeight, maxHeight);
  }

  onAutocompleteDropdownOpened() {
    this.virtualScroll.checkViewportSize();
  }

  onSearchChange() {
    if (this.virtualScroll) {
      this.virtualScroll.scrollToIndex(0);
    }
  }
  // displayFn(data1: any): string {
  //   console.log(data1);
  //   return '';
  // }

  // toggleSelection($event: any, item: any, field: any) {
  //   // $event.source.stopPropagation();
  //   console.log(item);
  //   console.log(field);
  //   console.log(this.form.controls);
  //   if (!this.form.controls[field.name].value) {
  //     this.form.controls[field.name].setValue([]);
  //   }
  //   if ($event) {
  //     const index = this.form.controls[field.name].value.indexOf(item);
  //     if (index >= 0) {
  //       this.form.controls[field.name].value.splice(index, 1);
  //     } else {
  //       this.form.controls[field.name].value.push(item);
  //     }
  //   }
  // }
  // getSelectedNames(field: any): string {
  //   if (this.form.controls[field.name].value.length > 0) {
  //     return this.form.controls[field.name].value
  //       .map((val: { key: string; value: string }) => val.value)
  //       .join(', ');
  //   }
  // }

  // onInputChange(event: Event, field: any): void {
  //   const target = event.target as HTMLInputElement;
  //   let searchVal = target.value.toLowerCase();

  //   if (!searchVal) {
  //     field.optionGroups = field.originalOptionGroups;
  //     return;
  //   }
  //   field.optionGroups = field.optionGroups
  //     .map((group: any) => {
  //       console.log(group);
  //       const titleMatches = group?.title?.toLowerCase().includes(searchVal);
  //       const filteredFields = group?.fields?.filter((opt: any) =>
  //         opt?.key?.toLowerCase().includes(searchVal),
  //       );
  //       if (titleMatches) {
  //         return group;
  //       }

  //       if (filteredFields?.length > 0) {
  //         return {
  //           ...group,
  //           fields: filteredFields,
  //         };
  //       }
  //     })
  //     .filter((group: any) => group !== null);
  // }

  // isSelected(data: any, field: any) {
  //   let selectedValues = this.form.controls[field.name]?.value;
  //   if (!selectedValues) {
  //     return false;
  //   }
  //   if (selectedValues) {
  //     return this.form.controls[field?.name]?.value?.some(
  //       (item: any) => item.value === data.value && item.key === data.key,
  //     );
  //   }
  // }
  ngDestroy() {}
}
